(() => {
  const key = 'klever.quote.return';
  const cartPath = (window.routes?.cart_url || '/cart').replace(/\/$/, '');
  const isCart = url => url.pathname.replace(/\/$/, '') === cartPath;
  const read = () => {
    try {
      const state = JSON.parse(sessionStorage.getItem(key) || 'null');
      const url = new URL(state?.url);
      return url.origin === location.origin && !isCart(url) ? state : null;
    } catch (_) { return null; }
  };
  const save = state => {
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) { /* Navigation still works without storage. */ }
  };
  // Capture before leaving, including the filters which are not encoded in the URL.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.matches('[data-klever-continue]')) {
      const state = read();
      if (!state || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      save({ ...state, restore: true });
      if (document.referrer === state.url && history.length > 1) history.back();
      else location.assign(state.url);
      return;
    }
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !isCart(destination) || isCart(new URL(location.href))) return;
    const panel = document.querySelector('#KleverCommercialFilters');
    save({
      url: location.href, x: window.scrollX, y: window.scrollY, restore: false,
      filters: [...(panel?.querySelectorAll('input') || [])].map(input => ({ value: input.value, checked: input.checked })),
      expanded: [...(panel?.querySelectorAll('details') || [])].map(details => details.open),
      view: document.querySelector('[data-catalog-view]')?.dataset.catalogView,
    });
    document.querySelector('#KleverQuoteConfirmation[open]')?.close();
  }, true);
  const state = read();
  const returnLink = document.querySelector('[data-klever-continue]');
  if (returnLink && state) returnLink.href = state.url;
  window.addEventListener('pageshow', () => {
    const saved = read();
    if (!saved?.restore || saved.url !== location.href) return;
    const panel = document.querySelector('#KleverCommercialFilters');
    panel?.querySelectorAll('input').forEach((input, index) => {
      const value = saved.filters?.[index];
      if (!value) return;
      input.value = value.value;
      input.checked = value.checked;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    panel?.querySelectorAll('details').forEach((details, index) => { details.open = !!saved.expanded?.[index]; });
    panel?.dispatchEvent(new Event('change', { bubbles: true }));
    if (saved.view === 'list' || saved.view === 'grid') {
      document.querySelector(`[data-catalog-view-button="${saved.view}"]`)?.click();
    }
    requestAnimationFrame(() => requestAnimationFrame(() => {
      window.scrollTo({ left: Number(saved.x) || 0, top: Number(saved.y) || 0, behavior: 'instant' });
      save({ ...saved, restore: false });
    }));
  });
})();
